// src/components/register/VideoSelector.tsx
import React from 'react';
import { HERO_VIDEO_OPTIONS, type HeroVideoKey } from '../../types/registration';
import mvSp from '../../assets/mv_sp.mp4';
import mvVideo1 from '../../assets/mv_video1.mp4';
import mvVideo2 from '../../assets/mv_video2.mp4';
import mvVideo3 from '../../assets/mv_video3.mp4';
import mvVideo4 from '../../assets/mv_video4.mp4';
import mvVideo5 from '../../assets/mv_video5.mp4';

// 動画ファイルのマッピング
const VIDEO_MAP: Record<HeroVideoKey, string> = {
  mv_sp: mvSp,
  mv_video1: mvVideo1,
  mv_video2: mvVideo2,
  mv_video3: mvVideo3,
  mv_video4: mvVideo4,
  mv_video5: mvVideo5,
};

interface VideoSelectorProps {
  selectedVideo: HeroVideoKey;
  onSelectVideo: (videoKey: HeroVideoKey) => void;
}

export const VideoSelector: React.FC<VideoSelectorProps> = ({ selectedVideo, onSelectVideo }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {HERO_VIDEO_OPTIONS.map((option) => {
        const isSelected = selectedVideo === option.value;
        const videoUrl = VIDEO_MAP[option.value];

        return (
          <div
            key={option.value}
            onClick={() => onSelectVideo(option.value)}
            className={`relative cursor-pointer rounded-lg border-2 overflow-hidden transition-all ${
              isSelected
                ? 'border-yellow-500 ring-2 ring-yellow-500 ring-offset-2'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <div className="aspect-video bg-gray-100">
              <video
                src={videoUrl}
                className="w-full h-full object-contain"
                muted
                loop
                playsInline
                onMouseEnter={(e) => e.currentTarget.play()}
                onMouseLeave={(e) => {
                  e.currentTarget.pause();
                  e.currentTarget.currentTime = 0;
                }}
              />
            </div>

            <div
              className={`p-2 text-center text-sm font-medium ${
                isSelected ? 'bg-yellow-50 text-yellow-900' : 'bg-white text-gray-700'
              }`}
            >
              {option.label}
            </div>

            {isSelected && (
              <div className="absolute top-2 right-2 w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
